import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth/core/AuthProvider'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { user } = useAuth()
  const scopeLevel = user?.scope?.level ?? 'none'
  const canViewScopedModules = scopeLevel !== 'none'
  const canManageUsers = user?.permissions?.canManageUsers ?? false
  const canManageCompanyData = user?.permissions?.canManageCompanyData ?? false
  const canManageSiteData = user?.permissions?.canManageSiteData ?? false
  const canAccessSettings = user?.permissions?.canAccessSettings ?? false
  const canAccessDataExport = user?.permissions?.canAccessDataExport ?? false
  const canAccessDataFiles = user?.permissions?.canAccessDataFiles ?? false
  const canAccessDataView = user?.permissions?.canAccessDataView ?? false
  const canAccessDataRequests = user?.permissions?.canAccessDataRequests ?? false
  const canAccessDataReliability = user?.permissions?.canAccessDataReliability ?? false
  const canAccessSecrReports = user?.permissions?.canAccessSecrReports ?? false
  const canAccessAnalyticsPrediction = user?.permissions?.canAccessAnalyticsPrediction ?? false
  const canAccessLoraDataCollections = user?.permissions?.canAccessLoraDataCollections ?? false
  const canAccessLoraLiveData = user?.permissions?.canAccessLoraLiveData ?? false
  const canAccessTaskManagement = user?.permissions?.canAccessTaskManagement ?? false
  const showDataMenu =
    canAccessDataFiles ||
    canAccessDataView ||
    canAccessDataExport ||
    canAccessDataReliability ||
    canAccessDataRequests

  if (!canManageCompanyData) {
    return (
      <>
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/art/art002.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
        {canManageSiteData && (
          <SidebarMenuItemWithSub
            to='#'
            title={intl.formatMessage({ id: 'MENU.COMPANY' })}
            fontIcon='far fa-building'
            icon='/media/icons/duotune/finance/fin006.svg'
          >
            <SidebarMenuItem
              to='/company/sites'
              title={intl.formatMessage({ id: 'MENU.COMPANYSITES' })}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/company/meters'
              title={intl.formatMessage({ id: 'MENU.COMPANYMETERS' })}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        )}
        {canAccessDataExport && (
          <SidebarMenuItem
            to='/data_export/list'
            icon='/media/icons/duotune/abstract/abs014.svg'
            title={intl.formatMessage({ id: 'MENU.DATAEXPORT' })}
            fontIcon='bi-app-indicator'
          />
        )}
        {canViewScopedModules && (
          <SidebarMenuItem
            to='/alarms/grouped'
            icon='/media/icons/duotune/general/gen007.svg'
            title={intl.formatMessage({ id: 'MENU.ALARMS' })}
            fontIcon='bi-app-indicator'
          />
        )}
        {canViewScopedModules && (
          <SidebarMenuItemWithSub
            to='#'
            title={intl.formatMessage({ id: 'MENU.REPORTS' })}
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/general/gen029.svg'
          >
            <SidebarMenuItem
              to='/reports/calendar'
              title={intl.formatMessage({ id: 'MENU.REPORTS.CALENDARVIEW' })}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        )}
        {canViewScopedModules && (
          <SidebarMenuItemWithSub
            to='#'
            title={intl.formatMessage({ id: 'MENU.BENCHMARK' })}
            fontIcon='bi-archive'
            icon='/media/icons/duotune/files/fil025.svg'
          >
            <SidebarMenuItem
              to='/benchmark/list'
              title={intl.formatMessage({ id: 'MENU.BENCHMARK.DASHBOARD' })}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/benchmark/charts'
              title={intl.formatMessage({ id: 'MENU.BENCHMARK.CHARTS' })}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        )}
        {canViewScopedModules && canAccessLoraLiveData && (
          <SidebarMenuItem
            to='/lora/live-data'
            icon='/media/icons/duotune/abstract/abs028.svg'
            title={intl.formatMessage({ id: 'MENU.LORA.LIVEDATA' })}
            fontIcon='bi-app-indicator'
          />
        )}
      </>
    )
  }
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/alarms/grouped'
        icon='/media/icons/duotune/general/gen007.svg'
        title={intl.formatMessage({ id: 'MENU.ALARMS' })}
        fontIcon='bi-app-indicator'
      />
      {showDataMenu && (
        <SidebarMenuItemWithSub
          to='#'
          title={intl.formatMessage({ id: 'MENU.DATA' })}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/abstract/abs014.svg'
        >
          {canAccessDataFiles && (
            <SidebarMenuItem
              to='/data_files/list'
              title={intl.formatMessage({ id: 'MENU.DATAFILES' })}
              hasBullet={true}
            />
          )}
          {canAccessDataView && (
            <SidebarMenuItem
              to='/data_view/list'
              title={intl.formatMessage({ id: 'MENU.DATAVIEW' })}
              hasBullet={true}
            />
          )}
          {canAccessDataExport && (
            <SidebarMenuItem
              to='/data_export/list'
              title={intl.formatMessage({ id: 'MENU.DATAEXPORT' })}
              hasBullet={true}
            />
          )}
          {canAccessDataReliability && (
            <SidebarMenuItem
              to='/data_reliability'
              title={intl.formatMessage({ id: 'MENU.DATARELIABILITY' })}
              hasBullet={true}
            />
          )}
          {canAccessDataRequests && (
            <SidebarMenuItemWithSub
              to='#'
              title={intl.formatMessage({ id: 'MENU.DATAREQUESTS' })}
              hasBullet={true}
            >
              <SidebarMenuItem
                to='/data_requests/list'
                title={intl.formatMessage({ id: 'MENU.DATAREQUESTS' })}
                hasBullet={true}
              />
              <SidebarMenuItem
                to='/data_requests/mailbox'
                title={intl.formatMessage({ id: 'MENU.DATACOLLECTIONS.MAILBOX' })}
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          )}
        </SidebarMenuItemWithSub>
      )}
      <SidebarMenuItemWithSub
        to='#'
        title={intl.formatMessage({ id: 'MENU.BENCHMARK' })}
        fontIcon='bi-archive'
        icon='/media/icons/duotune/files/fil025.svg'
      >
        <SidebarMenuItem
          to='/benchmark/list'
          title={intl.formatMessage({ id: 'MENU.BENCHMARK.DASHBOARD' })}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/benchmark/records'
          title={intl.formatMessage({ id: 'MENU.BENCHMARK.VIEWS' })}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/benchmark/charts'
          title={intl.formatMessage({ id: 'MENU.BENCHMARK.CHARTS' })}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/benchmark/heatmap'
          title={intl.formatMessage({ id: 'MENU.BENCHMARK.HEATMAP' })}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>

      {canAccessSecrReports && (
        <SidebarMenuItemWithSub
          to='#'
          title={intl.formatMessage({ id: 'MENU.SECRREPORTS' })}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/general/gen029.svg'
        >
          <SidebarMenuItem
            to='/secr_reports/secr_dashboard'
            title={intl.formatMessage({ id: 'MENU.SECR.DASHBOARD' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/secr_reports/list'
            title={intl.formatMessage({ id: 'MENU.SECRREPORTS' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/secr_documents/list'
            title={intl.formatMessage({ id: 'MENU.SECRDOCUMENTS' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}

      {canManageUsers && (
        <SidebarMenuItem
          to='/users/list'
          title={intl.formatMessage({ id: 'MENU.USERS' })}
          fontIcon='bi-user'
          icon='/media/icons/duotune/general/gen067.svg'
        />
      )}
      {canManageCompanyData && (
        <SidebarMenuItemWithSub
          to='#'
          title={intl.formatMessage({ id: 'MENU.COMPANY' })}
          fontIcon='far fa-building'
          icon='/media/icons/duotune/finance/fin006.svg'
        >
          <SidebarMenuItem
            to='/company/list'
            title={intl.formatMessage({ id: 'MENU.COMPANYLIST' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/company/sites'
            title={intl.formatMessage({ id: 'MENU.COMPANYSITES' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/company/meters'
            title={intl.formatMessage({ id: 'MENU.COMPANYMETERS' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/company/notes'
            title={intl.formatMessage({ id: 'MENU.COMPANY.NOTES' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}
      <SidebarMenuItemWithSub
        to='#'
        title={intl.formatMessage({ id: 'MENU.ANALYTICS' })}
        fontIcon='bi-archive'
        icon='/media/icons/duotune/abstract/abs001.svg'
      >
        <SidebarMenuItem
          to='/reports/calendar'
          title={intl.formatMessage({ id: 'MENU.REPORTS.CALENDARVIEW' })}
          icon='/media/icons/duotune/general/gen014.svg'
        />

        <SidebarMenuItem
          to='/reports/analytics-charts'
          title={intl.formatMessage({ id: 'REPORTS.ANALYTICSCHART' })}
          icon='/media/icons/duotune/abstract/abs046.svg'
        />
        {canAccessAnalyticsPrediction && (
          <SidebarMenuItem
            to='/reports/analytics-prediction'
            title={intl.formatMessage({ id: 'REPORTS.ANALYTICSPREDICTION' })}
            icon='/media/icons/duotune/abstract/abs047.svg'
          />
        )}
      </SidebarMenuItemWithSub>
      {canAccessSettings && (
        <SidebarMenuItemWithSub
          to='#'
          title={intl.formatMessage({ id: 'MENU.PROFILES' })}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs015.svg'
        >
          <SidebarMenuItem
            to='/profiles/list'
            title={intl.formatMessage({ id: 'MENU.PROFILES' })}
            icon='/media/icons/duotune/abstract/abs034.svg'
          />
          <SidebarMenuItem
            to='/simulations/list'
            title={intl.formatMessage({ id: 'MENU.SIMULATIONS' })}
            icon='/media/icons/duotune/abstract/abs042.svg'
          />
          <SidebarMenuItem
            to='/events/list'
            title={intl.formatMessage({ id: 'MENU.EVENTS' })}
            icon='/media/icons/duotune/abstract/abs026.svg'
          />
          <SidebarMenuItem
            to='/settings/event-types'
            title={intl.formatMessage({ id: 'MENU.SETTINGS.EVENTTYPES' })}
            icon='/media/icons/duotune/abstract/abs028.svg'
          />
        </SidebarMenuItemWithSub>
      )}
      {canAccessSettings && (
        <SidebarMenuItemWithSub
          to='#'
          title={intl.formatMessage({ id: 'MENU.SETTINGS' })}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/coding/cod001.svg'
        >
          <SidebarMenuItem
            to='/settings/sftp-config'
            title={intl.formatMessage({ id: 'MENU.SETTINGSSFTPCONFIG' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/settings/data-directory'
            title={intl.formatMessage({ id: 'MENU.SETTINGSDATADIRECTORY' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/settings/general-parameters'
            title={intl.formatMessage({ id: 'MENU.SETTINGSGENERALPARAMETERS' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/settings/conversion-factors'
            title={intl.formatMessage({ id: 'MENU.SETTINGSCONVERSIONFACTORS' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/settings/energy-types'
            title={intl.formatMessage({ id: 'MENU.SETTINGSENERGYTYPES' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/settings/energy-subtypes'
            title={intl.formatMessage({ id: 'MENU.SETTINGSENERGYSUBTYPES' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/settings/site-features'
            title={intl.formatMessage({ id: 'MENU.SETTINGS.SITEFEATURES' })}
            hasBullet={true}
          />
          <SidebarMenuItemWithSub
            to='#'
            title={intl.formatMessage({ id: 'MENU.SETTINGS.TASKSETTINGS' })}
            hasBullet={true}
          >
            <SidebarMenuItem
              to='/settings/task_categories'
              title={intl.formatMessage({ id: 'MENU.SETTINGS.TASKCATEGORIES' })}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/settings/task_subjects'
              title={intl.formatMessage({ id: 'MENU.SETTINGS.TASKSUBJECTS' })}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
          <SidebarMenuItem
            to='/settings/import-file-template'
            title={intl.formatMessage({ id: 'MENU.SETTINGS.IMPORTFILETEMPLATE' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}
      {canAccessLoraDataCollections && (
        <SidebarMenuItemWithSub
          to='#'
          icon='/media/icons/duotune/abstract/abs025.svg'
          title={intl.formatMessage({ id: 'MENU.LORA.DATACOLLECTIONS' })}
          fontIcon='bi-app-indicator'
        >
          <SidebarMenuItem
            to='/lora/dashboard'
            icon='/media/icons/duotune/abstract/abs026.svg'
            title={intl.formatMessage({ id: 'MENU.LORA.DASHBOARD' })}
            fontIcon='bi-app-indicator'
          />
          <SidebarMenuItem
            to='/lora/logs'
            icon='/media/icons/duotune/abstract/abs027.svg'
            title={intl.formatMessage({ id: 'MENU.LORA.LOGS' })}
            fontIcon='bi-app-indicator'
          />
          <SidebarMenuItem
            to='/lora/live-data'
            icon='/media/icons/duotune/abstract/abs028.svg'
            title={intl.formatMessage({ id: 'MENU.LORA.LIVEDATA' })}
            fontIcon='bi-app-indicator'
          />
        </SidebarMenuItemWithSub>
      )}
      {canAccessTaskManagement && (
        <SidebarMenuItem
          to='/company_tasks'
          icon='/media/icons/duotune/general/gen068.svg'
          title={intl.formatMessage({ id: 'MENU.TASKMANAGEMENT' })}
          fontIcon='bi-app-indicator'
        />
      )}
    </>
  )
}

export { SidebarMenuMain }
